import React from 'react';
import QRCode from 'react-qr-code';
import { VendexQrMeta } from '../../../models/VendexElement';
import { PageContext } from '../..';

export type QrConfig = {
  qrString: string;
  size: number;
};

type Props = {
  data: VendexQrMeta;
  id: string;
};

const VendexQR: React.FC<Props> = ({ data, id }) => {
  const { store } = React.useContext(PageContext);
  const value = data.type === "DYNAMIC"?store.data[data.content]:data.content;

  return <QRCode value={`${value}?deviceId=${window.DATA?.deviceId ?? ''}`} id={id} />;
};

export default VendexQR;
